import {useCallback, useMemo} from 'react'

import {CheckIcon} from '../../icons'
import {makeStyles, Theme} from '../../theme'
import {List, ListItem} from '../list'
import {geyYears} from './utils'

const YEARS = geyYears()

const useYearsListStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 'inherit',
    height: 240,
    paddingTop: 24,
  },
  listRoot: {
    display: 'flex',
    justifyContent: 'center',
  },
  list: {
    width: 240,
  },
  checkIcon: {
    color: theme.go.schemes.components.lists.selectedTextColor,
  },
}))

const asIs = (x: number) => `${x}`

export type YearsListProps = {years?: number[]; year: number; onItemClick: (year: number) => void}

export function YearsList({years, year, onItemClick}: YearsListProps) {
  const {root, list, listRoot, checkIcon} = useYearsListStyles()
  const selectedItems = useMemo(() => [year], [year])

  const renderItem = useCallback(
    (item: number, selected: boolean) => (
      <ListItem
        endElement={selected ? <CheckIcon className={checkIcon} /> : undefined}
        onClick={() => onItemClick(item)}
        selected={selected}
        title={`${item}`}
      />
    ),
    [checkIcon, onItemClick],
  )

  return (
    <div className={root}>
      <List
        classes={{list, root: listRoot}}
        getId={asIs}
        items={years ?? YEARS}
        renderItem={renderItem}
        selectedItems={selectedItems}
      />
    </div>
  )
}
